import { EcoaContent } from "@components/common/EconContent";
import React from "react";
import { useRouteMatch } from "react-router-dom";
import { Footer } from "@layouts/Footer";
import { PreScreeningNoticeSpec } from "maven-lib/dist/consts/edc/crf";
import { arrayify, hasOwnProperty } from "maven-lib/dist/utils/misc";
import { HbButton } from "@maven-surface/components/base/HbButton";
import { HbParagraph } from "@maven-surface/components/base/HbParagraph";
import { useRoute } from "@maven-surface/hooks/useRoute";
import { ECOA_CAPTURE_LANG } from "@maven-msg/lang/ecoaCapture";
import { MvnMessage } from "@maven-msg/lib/Message";

interface PreScreeningEntranceProps {
  notice: Array<PreScreeningNoticeSpec>;
}

export function PreScreeningEntrance(props: PreScreeningEntranceProps) {
  const { notice } = props;
  const { pushPath } = useRoute();
  const match = useRouteMatch();

  return (
    <>
      <EcoaContent>
        {arrayify(notice).map((text, index) => (
          <HbParagraph
            key={index}
            spacing={1}
            bold={text && hasOwnProperty(text, "bold") ? text.bold : false}
            align={text && hasOwnProperty(text, "align") ? text.align : "LEFT"}
            text={text && hasOwnProperty(text, "text") ? text.text : text}
            size={text && hasOwnProperty(text, "size") ? text.size : "X-LARGE"}
            color={((color) => (color === "RED" ? "DANGER" : color === "GRAY" ? "GRAY" : color === "BLUE" ? "PRIMARY" : undefined))(
              text && hasOwnProperty(text, "color") ? text.color : "BLACK"
            )}
          />
        ))}
      </EcoaContent>
      <Footer>
        <HbButton
          onClick={() => {
            pushPath(`${match.url}/1`);
          }}
          text={MvnMessage(ECOA_CAPTURE_LANG.ECOA_CAPTURE_TAKE_SURVEY)}
          iconRight="ChromeBackMirrored"
        />
      </Footer>
    </>
  );
}
